import { Injectable } from "@angular/core";
import { map, Observable } from "rxjs";

import { ApiService } from 'anatoliapps-angular/services';

import { Payment, PaymentCreateResponse, PaymentCreateResponseSchema, PaymentMethod, PaymentSchema } from 'hakikat/models';
import { API_CONFIG } from 'hakikat/utils';

@Injectable({
  providedIn: 'root'
})
export class PaymentService extends ApiService {

  //#region Endpoints
  readonly #PAYMENT_ENDPOINT = 'payment';
  //#endregion

  //#region Constructor
  constructor() { super(API_CONFIG.apiUrl); }
  //#endregion

  //#region Methods
  public getPayment(id: string): Observable<Payment> {
    return this.get<Payment>(`${this.#PAYMENT_ENDPOINT}/${id}`).pipe(
      map((response: Payment) => PaymentSchema.parse(response))
    );
  }

  public createPayment(oid: string, method: PaymentMethod): Observable<PaymentCreateResponse> {
    return this.post<PaymentCreateResponse>(this.#PAYMENT_ENDPOINT, { oid, method }).pipe(
      map((response: PaymentCreateResponse) => PaymentCreateResponseSchema.parse(response))
    );
  }
  //#endregion

  //#region Paypal Methods
  public getPaypalCapture(oid: string): Observable<any> {
    return this.get<any>(`${this.#PAYMENT_ENDPOINT}/paypal/${oid}`).pipe(
      map((response: any) => response)
    );
  }
  //#endregion
}